module.exports = __webpack_public_path__ + "img/ppt.a7e1da7c.png";